// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Oswald);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footerBar {
  position: relative;
  background-color: rgb(19, 19, 24);
  text-align: center;
  padding: 20px;
  width: 99.9vw;
  height: 150px;
  top: 98vh;
  right: 8px;
  box-shadow: 0px -8px 11px 0px rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: flex-start;
}

.dev {
  font: 500 20px 'Oswald';
  text-decoration: underline;
}

a {
  display: flex;
  flex-direction: column;
  color: white;
  text-align: start;
  text-decoration: none;
  transition: 0.3s;
}

a:hover {
  color: orange;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./client/features/footer/footer.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,aAAa;EACb,SAAS;EACT,UAAU;EACV,iDAAiD;EACjD,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B","sourcesContent":["@import url(//fonts.googleapis.com/css?family=Oswald);\r\n\r\n.footerBar {\r\n  position: relative;\r\n  background-color: rgb(19, 19, 24);\r\n  text-align: center;\r\n  padding: 20px;\r\n  width: 99.9vw;\r\n  height: 150px;\r\n  top: 98vh;\r\n  right: 8px;\r\n  box-shadow: 0px -8px 11px 0px rgba(0, 0, 0, 0.65);\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.dev {\r\n  font: 500 20px 'Oswald';\r\n  text-decoration: underline;\r\n}\r\n\r\na {\r\n  display: flex;\r\n  flex-direction: column;\r\n  color: white;\r\n  text-align: start;\r\n  text-decoration: none;\r\n  transition: 0.3s;\r\n}\r\n\r\na:hover {\r\n  color: orange;\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
